<template>
  <img :height="height" class="logo" alt="Yenza" data-pw=yenzaLogo src="../assets/logo.png"/>
</template>

<script setup lang="ts">
import {PropType} from "vue";

defineProps({
  height: {
    type: Number as PropType<number>,
    default: 40
  }
});
</script>
